import { _ as e } from "../internals/export.js";
import { r } from "../internals/regexp-exec.js";
e({
  target: "RegExp",
  proto: !0,
  forced: /./.exec !== r
}, {
  exec: r
});